import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'

(function () {
    Fancybox.defaults.Hash = false
    Fancybox.defaults.Images = {
        zoom: false,
    }
    Fancybox.defaults.Thumbs = false

    Fancybox.bind('[data-fancybox]', {
        zoom: true,
    })
})()
